export default "__VITE_ASSET__FCSPCXri__"